import {Component, OnInit, HostListener, Input, Inject} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthProfilesService } from '../../services/auth-profiles.service';
import { AuthProfile, AuthService } from '../../services/auth.service';
import { BandejaService } from '../../services/bandeja.service';
import { NavbarService } from './navbar.service';
import {DOCUMENT} from '@angular/common';
import {CodigoPerfil} from '../../constants/codigoPerfil';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    showRolSelector = false;
    showNotifications = false;
    showProfile = false;
    showInbox = false;

    searchTerm: string = '';
    mostrarPixeles = false

    userSigned;
    public innerWidth: any;
    headers;

    bandejaData = {
        idPadre: 0,
        personaPrincipal: '',
        perfiles: [],
        selected: undefined
    };

    authProfiles = []

    profileSelected: AuthProfile;

    loadingPerfiles = true

    @Input() showSearch = false
    showBandeja = true

    constructor(
        private expedienteService: BandejaService,
        private authService: AuthService,
        private service: NavbarService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authProfile: AuthProfilesService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.userSigned = authService.getProfile();
        this.showBandeja = !document.location.href.includes('/general')
        if (this.userSigned) {

            let n2 = ''
            let a2 = ''

            const n1 = this.userSigned.nombres.split(' ')
            if (n1[1]) {
                n2 = n1[1]
                n2 = ' ' + n2.split('')[0] + '.'
            }
            const a1 = this.userSigned.apellidos.split(' ')
            if (a1[1]) {
                a2 = a1[1]
                a2 = ' ' + a2.split('')[0] + '.'
            }

            this.userSigned.nombreSimplificado = `${n1[0]}${n2} ${a1[0]}${a2}`
        }

        this.headers = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        this.profileSelected = this.authService.getProfileSelected()

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((nav: NavigationEnd) => {
                if (
                    !nav.url.match('/busqueda-avanzada')
                    && !nav.url.match(/oefa$/)
                    && !nav.url.match(/usuario-final$/)
                    && !nav.url.match(/mesa-de-partes$/)
                ) {
                    this.showSearch = true
                }
                if (!nav.url.match(/general$/)) {this.showBandeja = true}
            })
    }

    @HostListener('window:mouseup', ['$event'])
    mouseUp(event) {
        const id = event.target.offsetParent?.id
        const target = event.target.offsetParent?.getAttribute('data-target')

        if (id != 'dropdown-bandeja' && target != 'dropdown-bandeja') this.showInbox = false
        if (id != 'roles-dropdown' && target != 'roles-dropdown') this.showRolSelector = false
        if (id != 'options-dropdown' && target != 'options-dropdown') this.showProfile = false
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.loadPerfilBandeja()
        this.authProfile.getPerfiles().subscribe(res => {
            if (res) this.authProfiles = res.filter(profile => {
                return profile.codigo != this.profileSelected.codigo
            })
        })
        this.profileSelected = this.authService.getProfileSelected()
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1600) {
            this.mostrarPixeles = true
        } else if (this.innerWidth > 1600) {
            this.mostrarPixeles = false
        }
    }

    dropToggle(event) {
        if (event.target.offsetParent.id == 'dropdown-bandeja') this.showInbox = !this.showInbox
        if (event.target.offsetParent.id == 'roles-dropdown') this.showRolSelector = !this.showRolSelector
        if (event.target.offsetParent.id == 'options-dropdown') this.showProfile = !this.showProfile
    }

    async loadPerfilBandeja() {
        this.loadingPerfiles = true
        const params = {
            userName: (<string>this.userSigned.username).toLowerCase()
        }

        const bandeja = JSON.parse(localStorage.getItem('bandeja'))


        try{
            await this.expedienteService.perfilBandeja(params, this.headers).then(({ list }: any) => {

                list.forEach((item, i) => {
                    if (item.username.match(/\d$/)) {
                        this.bandejaData.perfiles.push(item)
                    } else {
                        this.bandejaData.idPadre = item.id
                        this.bandejaData.personaPrincipal = item.username
                        this.bandejaData.perfiles.push(item)
                    }
                })

                if (bandeja) {
                    const exists = !!this.bandejaData.perfiles.filter(b => b.id == bandeja.id).length
                    if (!exists) {
                        this.bandejaData.selected = this.bandejaData.perfiles.find(p => p.predeterminado == 1) || this.bandejaData.perfiles[0]
                        localStorage.setItem('bandeja', JSON.stringify(this.bandejaData.selected))
                    } else {
                        this.bandejaData.selected = bandeja
                    }
                } else {
                    this.bandejaData.selected = this.bandejaData.perfiles.find(b => b.predeterminado == 1) || this.bandejaData.perfiles[0]
                    localStorage.setItem('bandeja', JSON.stringify(this.bandejaData.selected))
                }
                this.service.setBandejas(this.bandejaData)
                this.loadingPerfiles = false

            })
        }
        catch(e){

        }


        // if(this.bandejaData.perfiles.length == 0){
        //     this.logout();
        // }

    }

    setTipoBandeja(perfil) {
        this.showInbox = false
        this.bandejaData.selected = perfil
        this.service.setBandejas(this.bandejaData)
        localStorage.setItem('bandeja', JSON.stringify(this.bandejaData.selected))
        this.router.navigate([this.document.location.href])
         this.document.location.reload()
    }

    logout() {
        this.authService.logout()
        this.router.navigate(['/login'])
    }

    cambiarPerfil(profile, event?) {
        if (event) this.dropToggle(event)
        localStorage.setItem('siged-token-profile-selected', profile.codigo);
        this.router.navigate([profile.url])
    }



    logoOefa() {

        const urlAntigua = this.document.location.href;
        const urlNueva = urlAntigua.split('/');
        urlNueva.filter(
            url => {
                if (url === 'usuario-final') {
                    this.router.navigate(['/usuario-final'])
                }
                if (url === 'despacho') {
                    this.router.navigate(['despacho/emision-electronica/Recepcionar'])
                }
                if (url === 'digitalizacion') {
                    this.router.navigate(['digitalizacion/registro-guardado'])
                }
                if (url === 'control-calidad') {
                    this.router.navigate(['control-calidad/registro-guardado'])
                }
                if (url === 'mesa-de-partes') {
                    this.router.navigate(['mesa-de-partes/registro-guardado'])
                }
                if (url === 'administrador') {
                    this.router.navigate(['administrador/cargos'])
                }
                if (url === 'fedatario') {
                    this.router.navigate(['fedatario/listar-solicitudes'])
                }
            }
        )
    }
    setFavoriteBandeja(perfil) {
        this.service.setDefaultBandeja({
            idPadre: this.userSigned.id,
            idPersona: perfil.id
        }).then(res => this.setTipoBandeja(perfil))
    }
}
